import type { State } from './project-access-types';

export const accessTypesSelector = (state: State) => state.entities.accessTypes;

export const selectedAccessTypeSelector = (state: State) => state.ui.selectedAccessType;

export const isLoadingSelector = (state: State) => state.ui.isLoading;

export const hasFetchDataErrorSelector = (state: State) => state.ui.fetchDataError;

/** @deprecated baseUrl in cloud is an empty string. remove code that checks or uses it. */
export const baseUrlSelector = (_: unknown): string => '';

export const cloudNameSelector = (state: State) => state.context.cloudName;

export const isSiteAdminSelector = (state: State) => state.context.isSiteAdmin;

export const projectIdSelector = (state: State) => state.context.projectId;

export const projectTypeSelector = (state: State) => state.context.projectType;
